export const ADD_MAIL = 'ADD_MAIL'
export const ADD_EMAIL_ENUM = 'ADD_EMAIL_ENUM'